<template>
  <div>
    <h1>Lista de Usuários</h1>

    <b-card>
      <div class="d-flex mb-2">
        <div class="w-75 mr-auto">
          <b-input-group size="sm">
            <b-form-input
              v-model="termo_pesquisa"
              v-on:keyup.enter="searchTerm"
              placeholder="Pesquisar"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="searchTerm" variant="exitos">Buscar</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div>
          <b-button
            size="sm"
            variant="exitos"
            :to="{ name: 'users_create' }"
            v-if="$can('user:create')"
          >
            <font-awesome-icon icon="plus" />
            Novo
          </b-button>
        </div>
      </div>

      <b-table striped hover :items="users" :fields="fields" show-empty>
        <template #cell(roles)="{ item }">
          <div>
            <span
              v-for="(role, key) in item.roles"
              :key="key"
              class="list-role-item"
              >{{ role.name }}</span
            >
          </div>
        </template>
        <template #cell(ativo)="{ item }">
          <div class="text-center active-cell">
            <font-awesome-icon
              :icon="item.ativo ? 'check-circle' : 'times-circle'"
              :class="{ inactive: !item.ativo }"
            />
          </div>
        </template>
        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            :view_edit="$can('user:edit')"
            :view_delete="$can('user:delete')"
            edit_to="users_edit"
            @delete="delete_user"
          />
        </template>

        <template #empty="{}">
          <h5 class="text-center">Nenhum item encontado</h5>
        </template>
      </b-table>
    </b-card>

    <div class="overflow-auto mt-4">
      <b-pagination-nav
        v-model="page"
        @input="loadData()"
        :link-gen="linkGen"
        :number-of-pages="pagination.last_page"
        use-router
      ></b-pagination-nav>
    </div>
  </div>
</template>

<script>
import Actions from "@/components/Table/Actions.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Actions },
  data() {
    return {
      page: 1,
      termo_pesquisa: "",
      key: this.$route.meta.admins,
    };
  },
  computed: {
    ...mapState("users", ["users", "pagination"]),
    fields() {
      return [
        { key: "id", label: "COD", class: "col-1" },
        { key: "name", label: "Nome" },
        { key: "email", label: "Email" },
        { key: "ativo", label: "Ativo", class: "text-center" },
        { key: "roles", label: "Papeis" },
        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
  },
  methods: {
    ...mapActions("users", ["ActionGetAll", "ActionDelete"]),
    async delete_user(user) {
      try {
        await this.ActionDelete(user.id);
        this.$notifications.addNotification({
          message: "Registro deletado com sucesso",
          type: "success",
        });
        await this.loadData();
      } catch ({ body }) {
        let message = "Erro ao excluir registro";

        if (body && (body || {}).message) {
          message = [body.message, body.error].filter(Boolean).join(": ");
        }

        this.$notifications.addNotification({
          message,
          type: "danger",
        });
      }
    },
    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    },
    searchTerm() {
      this.page = 1;
      this.loadData();
      this.$router.push({
        query: {
          page: this.page,
          q: this.termo_pesquisa,
        },
      });
    },
    async loadData() {
      try {
        const params = {
          page: this.page,
          q: this.termo_pesquisa,
        };

        if (this.$route.meta.admins) {
          params.admins = true;
        }

        await this.ActionGetAll(params);
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao carregar dados da listagem",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
  },
  async created() {
    this.$watch(
      () => this.$route.meta.admins,
      () => {
        if (this.$route.query.page > 1) {
          this.page = this.$route.query.page;
        }
        if (this.$route.query.q != "") {
          this.termo_pesquisa = this.$route.query.q;
        }
        this.loadData();
      },
      // fetch the data when the view is created and the data is
      // already being observed
      { immediate: true }
    );
  },
};
</script>

<style lang="scss">
.list-role-item {
  background-color: #225373;
  color: #ffffff;
  padding: 0.1em 0.3em;
  border-radius: 3px;
  text-align: center;
  margin: 0.1em;
  white-space: nowrap;
  float: left;
}

.active-cell {
  font-size: 1.5em;
  color: #2dce89;

  .inactive {
    color: #f5365c;
  }
}
</style>
